import { toRem } from '@marriott/mi-ui-library';

//Adding some styles here as they are removed from shared/mi-ui-library
//Moving forward we should not use these mediaqueries. Use mediaqueries only from shared/mi-ui-library and follow mobile first approach
//TODO: Code needs to be updated where we are using these. These mediaqueries should be removed and what is imported from shared/mi-ui-library should be used.
//TODO: we can move these mediaqueries and fonts and alphaColor to common
export const mediaQuery = {
  mobileOnly: ` screen and (max-width: ${toRem(767)})`,
  minDesktop: ` screen and (min-width: ${toRem(1200)})`,
  tabletOnly: ` (min-width:${toRem(768)}) and (max-width:${toRem(991)})`,
  smallMobileOnly: ` screen and (max-width: ${toRem(350)})`,
  tabletMax: ` screen and (max-width: ${toRem(1199)})`,
  mobile: ` screen and (max-width: ${toRem(576)})`,
};

export const fonts = {
  fontWeightMedium: '700',
  fontWeightRegular: '500',
};
